// extracted by mini-css-extract-plugin
module.exports = {"welcomeContainer":"Welcome_welcomeContainer__3c3Ax","titulo":"Welcome_titulo__12_iz","boton":"Welcome_boton__2sZU_","imgWelcome":"Welcome_imgWelcome__367rK"};